import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

import { computed, PropType, provide } from 'vue'
import { storeToRefs } from 'pinia'
import { useSlidesStore } from '@/store'
import { Slide } from '@/types/slides'
import { injectKeySlideId } from '@/types/injectKey'
import { VIEWPORT_SIZE } from '@/configs/canvas'
import useSlideBackgroundStyle from '@/hooks/useSlideBackgroundStyle'

import ScreenElement from './ScreenElement.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ScreenSlide',
  props: {
  slide: {
    type: Object as PropType<Slide>,
    required: true,
  },
  scale: {
    type: Number,
    required: true,
  },
  animationIndex: {
    type: Number,
    required: true,
  },
  turnSlideToId: {
    type: Function as PropType<(id: string) => void>,
    required: true,
  },
  manualExitFullscreen: {
    type: Function as PropType<() => void>,
    required: true,
  },
},
  setup(__props) {

const props = __props



const { viewportRatio } = storeToRefs(useSlidesStore())

const background = computed(() => props.slide.background)
const { backgroundStyle } = useSlideBackgroundStyle(background)

const slideId = computed(() => props.slide.id)
provide(injectKeySlideId, slideId)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "screen-slide",
    style: _normalizeStyle({
      width: _unref(VIEWPORT_SIZE) + 'px',
      height: _unref(VIEWPORT_SIZE) * _unref(viewportRatio) + 'px',
      transform: `scale(${__props.scale})`,
    })
  }, [
    _createElementVNode("div", {
      class: "background",
      style: _normalizeStyle({ ..._unref(backgroundStyle) })
    }, null, 4),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.slide.elements, (element, index) => {
      return (_openBlock(), _createBlock(ScreenElement, {
        key: element.id,
        elementInfo: element,
        elementIndex: index + 1,
        animationIndex: __props.animationIndex,
        turnSlideToId: __props.turnSlideToId,
        manualExitFullscreen: __props.manualExitFullscreen
      }, null, 8, ["elementInfo", "elementIndex", "animationIndex", "turnSlideToId", "manualExitFullscreen"]))
    }), 128))
  ], 4))
}
}

})